import { z } from 'zod'

/**
 * backend が受け入れる UUID と同じ loose 形式 (8-4-4-4-12 の任意 hex) の
 * Zod schema を返す。
 *
 * Zod 4 の `z.string().uuid()` は RFC 9562 strict 検証 (version ニブル 1-8 +
 * variant 検証) であり、backend の受け入れ範囲 (protovalidate `string.uuid` /
 * Postgres `uuid` 型 = 任意 hex) より狭い。seed fixture の id
 * (例: `bbbbbbbb-bbbb-bbbb-bbbb-bbbbbbbbbbbb` = version b、
 * `5b000000-0000-0000-0000-000000000001` = version 0) が reject され、
 * select で選択しただけの正当な値に「UUID 形式で入力してください」エラーが
 * 出る実バグになった。frontend の format 検証は backend と同じ loose 形式に
 * 揃える。
 */
const LOOSE_UUID_RE =
  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/

export function uuidString(message: string): z.ZodString {
  return z.string().regex(LOOSE_UUID_RE, message)
}
